import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const CHAT_ROOMS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"chat_rooms"> = {
  updateOne: (_, mutationResponse) =>
    mutationResponse?.type === "internal" || !mutationResponse?.enduserIds?.length
      ? {
          // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
          load_team_chat: {
            exact: false,
          },
        }
      : {},
  createOne: (_, mutationResponse) =>
    mutationResponse?.type === "internal" || !mutationResponse?.enduserIds?.length
      ? {
          // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
          load_team_chat: {
            exact: false,
          },
        }
      : {},
  deleteOne: (_, mutationResponse) =>
    mutationResponse
      ? {
          // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
          load_team_chat: {
            exact: false,
          },
        }
      : {},
  createSome: (_, mutationResponse) =>
    mutationResponse?.created.some((room) => room.type === "internal" || !room.enduserIds?.length)
      ? {
          // Invalidate all load_team_chat queries until we have access to the current user ID in cache updates
          load_team_chat: {
            exact: false,
          },
        }
      : {},
};
